import { Link } from "react-router-dom";
import { ArrowDownRight, Play, Pause } from "lucide-react";
import { useRadio } from "@/context/RadioContext";

export const Hero = () => {
  const { playing, toggle } = useRadio();
  return (
    <section className="relative min-h-screen flex items-end overflow-hidden grain brand-glow" data-testid="home-hero">
      <div className="absolute inset-0 bg-[#0a0a0a]/30" />
      <div className="relative w-full max-w-[1600px] mx-auto px-5 md:px-10 pb-32 pt-36">
        <p className="text-xs sm:text-sm uppercase tracking-[0.3em] font-bold text-white/80 reveal">Le média, la radio</p>
        <div className="grid xl:grid-cols-[1fr_auto] gap-10 items-end mt-8 reveal" style={{ animationDelay: "100ms" }}>
          <div className="max-w-4xl">
            <h1 className="font-thin-brand uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-tight" data-testid="hero-headline">
              <span className="sr-only">LEGROSTASDEZIK (LGTDZ) — </span>
              SÉLECTIONS POINTUES, <span className="font-display text-primary block sm:whitespace-nowrap">TRANSMISSION DÉTENDUE</span>
            </h1>
            <p className="text-zinc-300 text-base sm:text-lg mt-4 leading-relaxed font-bold tracking-[0.2em]" data-testid="hero-subline">
              7/7 - 24/24
            </p>
          </div>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={toggle}
              data-testid="hero-listen-radio-btn"
              className="inline-flex items-center gap-3 bg-primary text-white font-display uppercase text-xl px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200"
            >
              {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5" />}
              {playing ? "Pause radio" : "Écouter la radio"}
            </button>
            <Link
              to="/agenda"
              data-testid="hero-agenda-btn"
              className="inline-flex items-center gap-3 border-2 border-white text-white font-display uppercase text-xl px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200"
            >
              L'agenda <ArrowDownRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

const WORDS = [
  { label: "Radio 7/7 - 24/24", to: "/radio", key: "radio" },
  { label: "Agenda", to: "/agenda", key: "agenda" },
  { label: "Magazine", to: "/news", key: "magazine" },
  { label: "Podcasts", to: "/radio#podcasts", key: "podcasts" },
  { label: "Arrivages", to: "/arrivages", key: "arrivages" },
  { label: "Artistes", to: "/artistes", key: "artistes" },
  { label: "Lieux", to: "/lieux", key: "lieux" },
];

// Repeated for a seamless loop; only the first copy is reachable by keyboard / screen readers.
export const Marquee = () => (
  <nav aria-label="Rubriques" className="bg-primary overflow-hidden border-y border-black py-4" data-testid="home-marquee">
    <div className="marquee-track flex w-max hover:[animation-play-state:paused]">
      {[0, 1, 2, 3].flatMap((copy) => WORDS.map((w) => (
        <Link key={`${copy}-${w.key}`} to={w.to} tabIndex={copy ? -1 : 0} aria-hidden={copy ? "true" : undefined}
          data-testid={copy ? undefined : `marquee-link-${w.key}`}
          className="group font-display uppercase text-2xl md:text-3xl text-black px-6 whitespace-nowrap">
          <span className="group-hover:text-white transition-colors duration-200">{w.label}</span> <span className="text-white ml-6">✦</span>
        </Link>
      )))}
    </div>
  </nav>
);
